import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./services";
import { LayoutComponent, ForbiddenComponent } from "./components";
import { DummyPageComponent } from "./components/dummy-page/dummy-page.component";
const pagesRoutes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    // canActivateChild: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "/overall-status",
        pathMatch: "full"
      },
      {
        path: "overall-status",
        canActivate: [AuthGuardService],
        loadChildren:
          "app/overall-status/overall-status.module#OverallStatusModule"
      },
      {
        path: "performance",
        loadChildren:
          "app/performance-dashboard/performance-dashboard.module#PerformanceDashboardModule"
      },
      {
        path: "warehousedashboard",
        loadChildren:
          "app/warehouse-dashboard/warehouse-dashboard.module#WarehouseDashboardModule"
        //canLoad: [AuthGuardService]
      },
      {
        path: "transportationdashboard",
        loadChildren:
          "app/transportation-dashboard/transportation-dashboard.module#TransportationDashboardModule"
        //canLoad: [AuthGuardService]
      },
      {
        path: "inventoryplanningdashboard",
        loadChildren:
          "app/inventory-planning-dashboard/inventory-planning-dashboard.module#InventoryPlanningDashboardModule"
        //canLoad: [AuthGuardService]
      },
      {
        path: "inventorydetailsdashboard",
        loadChildren:
          "app/inventory-details-dashboard/inventory-details-dashboard.module#InventoryDetailsDashboardModule"
        // canLoad: [AuthGuardService]
      },
      {
        path: "movementdetailsdashboard",
        loadChildren:
          "app/movement-details-dashboard/movement-details-dashboard.module#MovementDetailsDashboardModule"
        //canLoad: [AuthGuardService]
      },
      {
        path: "sales-forecast",
        loadChildren:
          "app/sales-forecast/sales-forecast.module#SalesForecastDashboardModule"
      },

      {
        path: "request-tracker",
        loadChildren:
          "app/request-tracker/request-tracker.module#RequestTrackerModule"
      },
      {
        path: "pickup-request",
        loadChildren: "app/pickup-request/pickup-request.module#PickupRequestModule"

      },
      {
        path: "orderdetail/:entity_type/:orderId",
        loadChildren: "app/movement-details-dashboard/components/order-details/order-details.module#OrderDetailsModule",
      },
      {
        path: "awbdetail/:entity_type/:awb_id",
        loadChildren: "app/movement-details-dashboard/components/awb-details/awb-details.module#AwbDetailsModule",
      },
      {
        path: "agndetails/:entity_type/:agn_id",
        loadChildren: "app/movement-details-dashboard/components/agn-details/agn-details.module#AgnDetailsModule"
      },
      {
        path: "user-management",
        loadChildren:
          "app/user-management-dashboard/user-management-dashboard.module#UserManagementDashboardModule"
      },
      {
        path: "fresh-desk",
        loadChildren: "app/fresh-desk/fresh-desk.module#FreshDeskModule"
      },
      {
        path: "client-management",
        loadChildren:
          "app/client-management/client-management.module#ClientManagementModule"
      },
      {
        path: "download-reports",
        loadChildren:
          "app/report-downlaod-dashboard/report-download.module#ReportDownloadModule"
      }
      // ,
      // {
      //   path: "dummy",
      //   component: DummyPageComponent
      // }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(pagesRoutes)],
  exports: [RouterModule]
})
export class CoreRoutesModule { }
